import { ReactNode } from 'react';
import styled from 'styled-components';

import { fontImportUrl } from 'dashboard/components/ThemedFonts/ThemedFonts';
import TextBase from 'inquiry/components/TextBase/TextBase';
import useExternalStylesheet from 'lib/hooks/useExternalStylesheet';
import { TextComponentStyles } from 'lib/interfaces/ui-components';
import { fontFamilyCss } from 'verify/lib/utils/font-family';

const Paragraph = styled('p')`
  font-family: ${({ theme: { fontFamily } }) => fontFamilyCss(fontFamily)};
  color: ${({ theme }) => theme.colorFont};
  font-size: ${({ theme }) => theme.fontSizeBody};
  line-height: ${({ theme }) => theme.lineHeightBody};
  text-align: ${({ theme }) => theme.textAlign};
`;

type TextBaseProps = {
  className?: string;
  id?: string;
  styles?: TextComponentStyles;
  children: ReactNode;
};

const ThemedParagraph = ({ styles, ...rest }: TextBaseProps) => {
  useExternalStylesheet(fontImportUrl(styles?.['font-family'].base.base));

  return <>{styles != null ? <TextBase {...rest} styles={styles} /> : <Paragraph {...rest} />}</>;
};

export default ThemedParagraph;
